export var ConnectionCloseReason;
(function (ConnectionCloseReason) {
    ConnectionCloseReason["ClosedByClient"] = "ClosedByClient";
    ConnectionCloseReason["ClosedByServer"] = "ClosedByServer";
    ConnectionCloseReason["HeartbeatTimeout"] = "HeartbeatTimeout";
    ConnectionCloseReason["Unknown"] = "unknown";
})(ConnectionCloseReason || (ConnectionCloseReason = {}));
export function GetCloseReasonByServerCode(code) {
    if (code === 1000) {
        return ConnectionCloseReason.ClosedByClient;
    }
    if (code === 3001) {
        return ConnectionCloseReason.HeartbeatTimeout;
    }
    else if (code >= 3000) {
        return ConnectionCloseReason.ClosedByServer;
    }
    else {
        return ConnectionCloseReason.Unknown;
    }
}
